import React from 'react';
import { Button } from 'antd';
import { LinkOutlined, PictureOutlined } from '@ant-design/icons';
import DeleteButton from 'components/DeleteButtonRedux';
import { getLinkTarget } from 'utils';
import './LinkPicker.scss';

const LinkPicker = props => {
	const {
		onClick,
		placeholderStr,
		onConfirm,
		mediaPicker,
		onPress,
		linkString: _linkString,
	} = props;
	const linkString = _linkString || getLinkTarget(onPress);
	return (
		<div className="LinkPicker">
			<Button
				icon={mediaPicker ? <PictureOutlined /> : <LinkOutlined />}
				onClick={onClick}
				className="LinkPickerButton"
			>
				<span className="LinkPickerText">{linkString ? linkString : placeholderStr}</span>
			</Button>
			{linkString && (
				<div className="LinkPickerDelete">
					<DeleteButton onConfirm={onConfirm} />
				</div>
			)}
		</div>
	);
};

export default LinkPicker;
